var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tags-field"},[_c('vSelect',{attrs:{"label":"name","taggable":"","value":_vm.tags,"filterable":false,"multiple":"","options":_vm.options,"on-change":_vm.fieldUpdated},on:{"search":_vm.onSearch}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }